export default {
  name: "Footer",
  props: {
    backgroundDirection: String,
  },
};
